// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__ujuhz","label":"Section_label__1cdPh","contentWrap":"Section_contentWrap__3VWTo","footer":"Section_footer__3NDYg","footerInner":"Section_footerInner__1JidA"};